<template>
  <div class="achievement-show-container">
    <div class="title">成果展品</div>
    <div class="scroll-container" ref="scrollContainer">
      <div class="scroll-content" ref="scrollContent">
        <div v-for="(item, index) in achievementItems" :key="index" class="achievement-item">
          <div class="achievement-image-container">
            <img v-if="item && item.image" :src="item.image" :alt="item.name" class="achievement-image">
            <div v-else class="achievement-image-placeholder">
              <i class="el-icon-picture-outline"></i>
            </div>
          </div>
          <div class="achievement-text-container">
            <div class="achievement-name">{{ item.name }}</div>
            <div class="achievement-description">{{ item.description }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ServiceAchievementController from '../../../api/Controller/ServiceAchievementController'
import { uploadMixin } from '@/core/mixins'

export default {
  name: 'AchievementShow',
  mixins: [uploadMixin],
  data () {
    return {
      // 成果展品数据
      achievementItems: [],
      scrollTimer: null,
      scrollSpeed: 1 // 滚动速度
    }
  },
  mounted () {
    this.fetchServiceAchievements()
  },
  beforeDestroy () {
    this.stopScroll()
  },
  methods: {
    // 获取服务成果数据
    fetchServiceAchievements () {
      ServiceAchievementController.list(this, {})
        .then(res => {
          console.log('服务成果数据:', res)

          // 处理API响应，兼容dataList和list格式
          let serviceAchievements = []
          if (res.data && res.data.dataList) {
            serviceAchievements = res.data.dataList
          } else if (res.data && res.data.list) {
            serviceAchievements = res.data.list
          } else if (res.data) {
            serviceAchievements = res.data
          }

          // 转换数据格式以匹配前端组件需求
          const formattedItems = serviceAchievements.map(item => {
            // 解析图片数据，参考Specialists.vue的逻辑
            let image = require('../../../assets/img/bigScreen/qiye.png');
            if (item.imageUrl) {
              try {
                const imageItems = this.parseUploadData(item.imageUrl, {id: item.id, fieldName: 'imageUrl', asImage: true});
                if (imageItems && imageItems.length > 0) {
                  image = imageItems[0].url;
                }
              } catch (e) {
                console.error('解析图片数据失败:', e);
              }
            }

            return {
              image: image,
              name: item.achievementName || '未知产品',
              description: item.achievementDesc || '暂无描述',
              originalImageUrl: item.imageUrl,
              id: item.id
            }
          })

          // 复制数据实现无缝滚动
          this.achievementItems = [...formattedItems, ...formattedItems]

          // 数据加载完成后开始滚动
          this.startScroll()
        })
        .catch(error => {
          console.error('获取服务成果数据失败:', error)

          // 错误时使用默认数据
          const defaultItems = []

          this.achievementItems = [...defaultItems, ...defaultItems]
          this.startScroll()
        })
    },
    startScroll () {
      const scrollContainer = this.$refs.scrollContainer
      const scrollContent = this.$refs.scrollContent

      if (!scrollContainer || !scrollContent) return

      this.scrollTimer = setInterval(() => {
        scrollContainer.scrollLeft += this.scrollSpeed

        // 当滚动到原始数据的一半时，无缝跳回开头
        // 这样可以实现平滑的无缝滚动
        if (scrollContainer.scrollLeft >= scrollContent.scrollWidth / 2) {
          scrollContainer.scrollLeft = 0
        }
      }, 30)
    },
    stopScroll () {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer)
        this.scrollTimer = null
      }
    }
  }
}
</script>

<style scoped>
.title {
  font-size: 20px;
  font-weight: bold;
  color: #ffd700;
  text-align: center;
  margin-bottom: 10px;
  text-shadow: 2px 2px 4px #2c2c2c, 0 0 10px #ffd700, 0 0 20px #ffd700;
  -webkit-text-stroke: 1px #333;
  //padding: 5px 15px;
}
.achievement-show-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  padding: 20px;
  box-sizing: border-box;
}

.scroll-container {
  width: 100%;
  height: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  /* 隐藏滚动条 */
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.scroll-container::-webkit-scrollbar {
  display: none;
}

.scroll-content {
  display: flex;
  gap: 10px;
  padding: 0;
  height: calc(100% - 40px);
  box-sizing: border-box;
  align-items: center;
}

.achievement-item {
  min-width: 280px;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  box-sizing: border-box;
}

.achievement-image-container {
  width: 100%;
  height: 150px;
  background-image: url(../../../assets/img/bigScreen/img_box_1.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  //margin-bottom: 10px;
  padding: 5px;
  box-sizing: border-box;
}

.achievement-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.achievement-image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(1, 185, 183, 0.1);
  border-radius: 4px;
}

.achievement-image-placeholder i {
  font-size: 40px;
  color: rgba(1, 185, 183, 0.5);
}

.achievement-text-container {
  flex: 1;
  background-image: url(../../../assets/img/bigScreen/img_box_2.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 15px 15px 0px 15px;
  box-sizing: border-box;
  min-height: 150px;
}

.achievement-name {
  width: 100%;
  text-align: center;
  color: #c1e7bc;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 8px;
  background-image: url(../../../assets/img/bigScreen/tiitle_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 5px 10px;
  box-sizing: border-box;
  display: inline-block;
}

.achievement-description {
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  line-height: 1.4;
  flex: 1;
  overflow: hidden;
  color: #e0efde;
  /*text-overflow: ellipsis;*/
  /*display: -webkit-box;*/
  //-webkit-line-clamp: 3;
  //-webkit-box-orient: vertical;
}
</style>
